import { type ParsedUrlQuery } from 'node:querystring';

import { QueryParamNames } from '~/constants/search';

/** A repeated query parameter is malformed, but using its first value is a safe and deterministic fallback. */
export const parseComparisonClipId = (query: ParsedUrlQuery): string | undefined => {
  const value = query[QueryParamNames.comparisonClipId];
  const firstValue = Array.isArray(value) ? value[0] : value;

  return firstValue || undefined;
};
